import styled from "@emotion/styled";
const MessageList = {
    Wrapper: styled.div `
    flex: auto;
    flex-direction: column;
    background-color: ${({ theme }) => theme.color.background};
    overflow-y: auto;
    *::-webkit-scrollbar {
      width: 0.7em;
    }
    *::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.color.background};
    }
    *::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.scrollbar};
      border-radius: 2em;
      border: 0.3em solid ${({ theme }) => theme.color.scrollbar};
    }
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => `${theme.color.scrollbar} ${theme.color.background}`};
  `,
    Spinner: styled.div `
    border-radius: 50%;
    width: 1em;
    height: 1em;
    border: 0.1em solid #ccc;
    border-top: 0.1em solid #777;
    animation: rotating 1.2s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
    @keyframes rotating {
      100% {
        transform: rotate(360deg);
      }
    }
  `,
    Loader: styled.div `
    display: ${({ isComplete }) => isComplete ? "none" : "flex"};
    padding: 0.5em;
    justify-content: center;
  `,
    NewLine: styled.p `
    width: auto;
    text-align: right;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    grid-gap: 0.5em;
    color: ${({ theme }) => theme.color.danger};
    margin: 0 1.5em 0 0;

    &:before {
      content: "";
      width: 100%;
      height: 1px;
      background: ${({ theme }) => theme.color.danger};
      opacity: 0.5;
    }
  `,
};
export default MessageList;
//# sourceMappingURL=MessageList.styled.js.map